import {AnalysesRoutes} from 'analyses/routes/AnalysesRoutes';
import {AnalysisTemplateRoutes} from 'analysis-tool/templates/routes/AnalysisTemplateRoutes';
import {ProteinCreationRoutes} from 'antibodies/nested-data-creation/full-screen/ProteinCreationRoutes';
import {JellyfishRoutes} from 'app-core/archetype/routes/JellyfishRoutes';
import {OAuthRoutes} from 'auth/oauth/routes/OAuthRoutes';
import {AuthRoutes} from 'auth/routes/AuthRoutes';
import {BenchlingAppsRoutes} from 'benchling-apps/routes/BenchlingAppsRoutes';
import {BulkWorkflowsRoutes} from 'bulk-workflows/routes/BulkWorkflowsRoutes';
import {CalendarRoutes} from 'calendar/routes/CalendarRoutes';
import {CanvasCoreRoutes} from 'canvas-core/routes/CanvasCoreRoutes';
import {ChemistryRoutes} from 'chemistry/routes/ChemistryRoutes';
import {ConfigMigrationRoutes} from 'config-migration/routes/ConfigMigrationRoutes';
import {DevPlatformRoutes} from 'dev-platform/routes/DevPlatformRoutes';
import {EventsRoutes} from 'events/routes/EventsRoutes';
import {FilesRoutes} from 'files/routes/FilesRoutes';
import {FormsRoutes} from 'forms/routes/FormsRoutes';
import {GrowthRoutes} from 'growth/routes/GrowthRoutes';
import {InsightsRoutes} from 'insights/routes/InsightsRoutes';
import {InstitutionsRoutes} from 'institutions/routes/InstitutionsRoutes';
import {InstrumentsRoutes} from 'instruments/routes/InstrumentsRoutes';
import {InventoryRoutes} from 'inventory/routes/InventoryRoutes';
import {LabelPrintingRoutes} from 'label-printing/routes/LabelPrintingRoutes';
import {AIRoutes} from 'llm/routes/AIRoutes';
import {ModBioRoutes} from 'modbio/routes/ModBioRoutes';
import {ModelHubRoutes} from 'model-hub/routes/ModelHubRoutes';
import {NavRoutes} from 'nav/routes/NavRoutes';
import {LibraryRoutes} from 'notebook/library/routes/LibraryRoutes';
import {NotebookRoutes} from 'notebook/routes/NotebookRoutes';
import {WorksheetRoutes} from 'notebook/worksheets/routes/WorksheetRoutes';
import {OnboardingRoutes} from 'onboarding/routes/OnboardingRoutes';
import {PartiesRoutes} from 'parties/routes/PartiesRoutes';
import {PlateDesignTemplateRoutes} from 'plates/plate-design-templates/routes/PlateDesignTemplateRoutes';
import {ParameterLibraryRoutes} from 'procedures/parameter-library/routes/ParameterLibraryRoutes';
import {ProceduresRoutes} from 'procedures/routes/ProceduresRoutes';
import {RequestsV2Routes} from 'processes/requests_v2/routes/RequestsV2Routes';
import {ProcessesRoutes} from 'processes/routes/ProcessesRoutes';
import {ProfileRoutes} from 'profile/routes/ProfileRoutes';
import {RegistryRoutes} from 'registry/routes/RegistryRoutes';
import {RequestsRoutes} from 'requests/routes/RequestsRoutes';
import {ResultsRoutes} from 'results/routes/ResultsRoutes';
import findClashingUrlPatterns from 'routing/findClashingUrlPatterns';
import {LegacyUrlPatternPrecedence} from 'routing/LegacyUrlPatternPrecedence';
import noOpRoute from 'routing/noOpRoute';
import {LegacyRoute, Route, RouteBundle, RouteManifest} from 'routing/RouteConstants';
import {RunsRoutes} from 'runs/routes/RunsRoutes';
import {SampleTestsRoutes} from 'sample-tests/routes/SampleTestsRoutes';
import {SampleTypesRoutes} from 'sample-types/SampleTypesRoutes';
import {SamplesRoutes} from 'samples/routes/SamplesRoutes';
import {SchemasRoutes} from 'schemas/routes/SchemasRoutes';
import {SearchRoutes} from 'search/routes/SearchRoutes';
import {StartRoutes} from 'start/routes/StartRoutes';
import {StudyRoutes} from 'studies/routes/StudyRoutes';
import {TenantComparisonRoutes} from 'tenant-comparison/routes/TenantComparisonRoutes';
import {TenantRoutes} from 'tenants/routes/TenantRoutes';
import {UnitsRoutes} from 'units/UnitsRoutes';
import {UseradminRoutes} from 'useradmin/routes/UseradminRoutes';
import {WorkflowsRoutes} from 'workflows/routes/WorkflowsRoutes';
import {WorklistsRoutes} from 'worklists/routes/WorklistsRoutes';

/**
 * This is where you should add your new `RouteBundle` objects!
 */
const routeBundles: Array<RouteBundle> = [
  AIRoutes,
  AnalysesRoutes,
  AnalysisTemplateRoutes,
  JellyfishRoutes,
  AuthRoutes,
  BenchlingAppsRoutes,
  BulkWorkflowsRoutes,
  CalendarRoutes,
  CanvasCoreRoutes,
  ChemistryRoutes,
  ConfigMigrationRoutes,
  DevPlatformRoutes,
  EventsRoutes,
  FilesRoutes,
  FormsRoutes,
  GrowthRoutes,
  InsightsRoutes,
  InstitutionsRoutes,
  InstrumentsRoutes,
  InventoryRoutes,
  LabelPrintingRoutes,
  LibraryRoutes,
  ModBioRoutes,
  ModelHubRoutes,
  NavRoutes,
  NotebookRoutes,
  OAuthRoutes,
  OnboardingRoutes,
  ParameterLibraryRoutes,
  PartiesRoutes,
  PlateDesignTemplateRoutes,
  ProceduresRoutes,
  ProcessesRoutes,
  ProfileRoutes,
  ProteinCreationRoutes,
  RegistryRoutes,
  RequestsRoutes,
  RequestsV2Routes,
  ResultsRoutes,
  RunsRoutes,
  SamplesRoutes,
  SampleTestsRoutes,
  SampleTypesRoutes,
  SchemasRoutes,
  SearchRoutes,
  StartRoutes,
  StudyRoutes,
  TenantComparisonRoutes,
  TenantRoutes,
  UnitsRoutes,
  UseradminRoutes,
  WorkflowsRoutes,
  WorklistsRoutes,
  WorksheetRoutes,
];

// pattern for matching to urls that don't match anythign else.
const DEFAULT_PATTERN = '*default';

// Error messages possibly thrown during the execution of `getRouteManifest`. Exported for use in tests.
export const CANT_FIND_NEXT_ROUTE_MSG =
  'Cannot find next route to add to route-manifest. There is probably a legacy route missing from the ' +
  'route-bundles, or some route bundles contain legacy routes in the wrong order.';
export const DIDNT_FIND_ALL_LEGACY_ROUTES_MSG = 'Did not find all legacy url patterns in the route bundles.';
export const FOUND_DEFAULT_TOO_EARLY =
  `Default url-pattern ${DEFAULT_PATTERN} found in route manifest too early. Is it mistakenly defined in ` +
  'one of the route bundles?';

/**
 * This function is responsible for merging the RouteBundle objects into something the Router can use. This is
 * not trivial because the merge needs to respect both the legacy precedence of routes and the precedence
 * internal to each RouteBundle.
 *
 * @param bundles Array of RouteBundle objects. This should always be the default value (`routeBundles`
 * defined above) in production code, but it is useful to pass other things in for testing.
 * @returns A map from url-patterns to functions, to be used in Router.tsx
 *
 * The general strategy of this function is to have a list of pointers to the array of routes in each bundle,
 * as well as a pointer to the LegacyUrlPatternPrecedence list. At each moment, unless we've got them all,
 * there is a next legacy-route we're looking for; if none of the pointers are looking at it, we pick a
 * pointer that is not currently looking at a legacy route, add the route it's looking at
 * to the manifest, advance the pointer, and check again. If a pointer *is* looking at it, we add it to the
 * manifest, advance that pointer, and advance the LegacyUrlPatternPrecdence pointer.
 *
 * This only works if:
 *  a) all of the routes that appear in LegacyUrlPatternPrecedence are somewhere among the route bundles (or
 * in the `oldMap` parameter), and
 *  b) the relative order of legacy routes in route bundles is the same as the relative order of those routes
 * in LegacyUrlPatternPrecedence.
 * If either of those things are not true, this code with throw a TypeError.
 */
export default function getRouteManifest(bundles: Array<RouteBundle> = routeBundles): RouteManifest {
  // Detect clashes in precedence between url-patterns, if running in development, or in unit tests.
  if (window.debug) {
    errorIfClashingPairs(bundles);
  }

  // The object that will ultimately be returned.
  const routeManifest: RouteManifest = {};

  /*
  Where we keep track of the index of each route, in each bundle, we are currently looking at, to determine
  which to add next to the `routeManifest`.
  */
  const currentBundleRoutesIndices: Array<number> = Array(bundles.length).fill(0);

  /*
  Pointer we use to march up the LegacyUrlPatternPredence list; we use it to make sure we put the nth
  legacy urlPattern into the route manifest before we put in the n+1th.
  */
  let legacyPrecedenceIndex = 0;
  // While at least one pointer to an array of routes in a bundle is less than the length of the array:
  while (
    currentBundleRoutesIndices.some(
      (routesIndex, bundleIndex) => routesIndex < bundles[bundleIndex].routes.length
    )
  ) {
    // The route we are going to add to the manifest this iteration.
    let currentRoute: Route | LegacyRoute;
    // The patterns currently pointed to by the `currentBundlesRoutesIndices`.
    const currentPatterns = bundles.map(
      (bundle, bundleIndex) => bundle.routes[currentBundleRoutesIndices[bundleIndex]]?.urlPattern
    );
    // Is there a legacy pattern we are currently looking for, and is it among the current route-bundle
    // patterns?
    const currentLegacyPattern = LegacyUrlPatternPrecedence[legacyPrecedenceIndex];
    const legacyInCurrent = currentPatterns.indexOf(currentLegacyPattern);
    // If so...
    if (currentLegacyPattern !== undefined && legacyInCurrent >= 0) {
      // ...the route we'll add next is the one with that legacy pattern.
      currentRoute = bundles[legacyInCurrent].routes[currentBundleRoutesIndices[legacyInCurrent]];
      // Advance the pointer up the list of legacy patterns
      legacyPrecedenceIndex += 1;
      // Advance the pointer past `currentRoute` in its route-bundle.
      currentBundleRoutesIndices[legacyInCurrent] += 1;
      // If not...
    } else {
      // ...find the next pointer in our array of pointers that isn't past the end of its bundle yet, and
      // isn't pointing at a legacy route.
      const currentBundleIndex = bundles.findIndex((bundle, bundleIndex) => {
        const routesIndex = currentBundleRoutesIndices[bundleIndex];
        return routesIndex < bundle.routes.length && bundle.routes[routesIndex].legacy !== true;
      });
      // If there isn't such a pointer, something had gone wrong.
      if (currentBundleIndex === -1) {
        throw Error(CANT_FIND_NEXT_ROUTE_MSG);
      }
      // If there is such a pointer, the route we'll add next is the one that pointer is pointing to.
      currentRoute = bundles[currentBundleIndex].routes[currentBundleRoutesIndices[currentBundleIndex]];
      // Advance that pointer past `currentRoute` in its bundle.
      currentBundleRoutesIndices[currentBundleIndex] += 1;
    }
    // Add `currentRoute` to the route-manifest.
    routeManifest[currentRoute.urlPattern] = currentRoute.handler;
  }
  if (legacyPrecedenceIndex < LegacyUrlPatternPrecedence.length) {
    throw new Error(DIDNT_FIND_ALL_LEGACY_ROUTES_MSG);
  }
  if (routeManifest[DEFAULT_PATTERN] != null) {
    throw new Error(FOUND_DEFAULT_TOO_EARLY);
  }
  routeManifest[DEFAULT_PATTERN] = noOpRoute;

  return routeManifest;
}

function errorIfClashingPairs(bundles: Array<RouteBundle>): void {
  const clashingPairs = findClashingUrlPatterns(bundles);
  if (clashingPairs.length > 0) {
    const errorMessage = clashingPairs.reduce(
      (accum, [[pattern1, domain1], [pattern2, domain2]]) =>
        `${accum}${pattern1} in route-bundle ${domain1}, ${pattern2} in route-bundle ${domain2}\n`,
      ''
    );
    throw new Error(`Clashing url-patterns:\n${errorMessage}`);
  }
}
